export default __webpack_public_path__ + "static/media/banner1.d35d34bc.jpg";